export class Tabs {
  constructor(element) {
    this.tabs = [...element.querySelectorAll("[role='tab']")];
    this.panels = [...element.querySelectorAll("[role='tabpanel']")];

    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        this.select(index);
      });

      tab.addEventListener("keydown", (event) => {
        this.onKeydown(event, index);
      });
    });
  }

  select(index, focus = false) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute("aria-selected", selected ? "true" : "false");
      tab.tabIndex = selected ? 0 : -1;
      this.panels[i].hidden = !selected;
    });

    if (focus) {
      this.tabs[index].focus();
    }
  }

  onKeydown(event, index) {
    const lastIndex = this.tabs.length - 1;
    let targetIndex = null;

    if (event.key === "ArrowRight") {
      targetIndex = index === lastIndex ? 0 : index + 1;
    } else if (event.key === "ArrowLeft") {
      targetIndex = index === 0 ? lastIndex : index - 1;
    } else if (event.key === "Home") {
      targetIndex = 0;
    } else if (event.key === "End") {
      targetIndex = lastIndex;
    }

    if (targetIndex === null) {
      return;
    }

    event.preventDefault();
    this.select(targetIndex, true);
  }
}
